import { cn } from "@/lib/utils";

type SwitchProps = {
  id?: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  "aria-label"?: string;
};

export function Switch({ id, checked, disabled, onCheckedChange, "aria-label": ariaLabel }: SwitchProps) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onCheckedChange?.(!checked)}
      className={cn(
        "relative inline-flex h-6 w-11 shrink-0 rounded-full border transition",
        checked ? "border-gray-900 bg-gray-900 dark:border-white dark:bg-white" : "border-gray-300 bg-gray-200 dark:border-white/20 dark:bg-white/10",
        disabled && "opacity-50",
      )}
    >
      <span
        className={cn(
          "pointer-events-none inline-block size-5 translate-y-0.5 rounded-full bg-white shadow transition",
          checked ? "translate-x-5 dark:bg-gray-900" : "translate-x-0.5",
        )}
      />
    </button>
  );
}
